// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { f_tool_scale_get, f_tool_scale_list } from '@/utils/scale';
import Cookies from 'js-cookie';
import CryptoJS, { MD5 } from 'crypto-js';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  try {
    let v_thepkg = "";
    const v_sitemyid = "4";
    const v_authTOken =Cookies.get('authToken');
    v_thepkg = f_tool_scale_list([v_authTOken||'',v_sitemyid]); 
    const response = await request<any>('/dopost/bh/port/2501', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/text',
        },
        data: v_thepkg,
        ...(options || {}),
      });
    if (response && response.oret =="1") {
      var userAccess = response.info.access || 'user';    
      var v_user ={        
        data: {
          name: '猋行',
          avatar:
            'https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png',
          userid: '00000001',
          email: 'antdesign@alipay.com',
          signature: '海纳百川，有容乃大',
          title: '交互专家',
          group: '蚂蚁金服－某某某事业群－某某平台部－某某技术部－UED',
          tags: [
            {
              key: '0',
              label: '很有想法的',
            },
            {
              key: '1',
              label: '专注设计',
            },
            {
              key: '2',
              label: '辣~',
            },
            {
              key: '3',
              label: '大长腿',
            },
            {
              key: '4',
              label: '川妹子',
            },
            {
              key: '5',
              label: '海纳百川',
            },
          ],
          notifyCount: 12,
          unreadCount: 11,
          country: 'China',
          access: userAccess,//'',//getAccess(),
          geographic: {
            province: {
              label: '浙江省',
              key: '330000',
            },
            city: {
              label: '杭州市',
              key: '330100',
            },
          },
          address: '西湖区工专路 77 号',
          phone: '0752-268888888',
        },
      };
     
     return (
      v_user
      );
    }else{
      return null;
    }

  } catch (error) {
    console.error('Failed to fetch current user:', error);
    throw error;
  }
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  try {
    // Remove token cookie
    Cookies.remove('authToken');
    
    const response = await request<Record<string, any>>('/api/login/outLogin', {
      method: 'POST',
      ...(options || {}),
    });
    
    return response;
  } catch (error) {
    // Even if API call fails, still remove the cookie
    Cookies.remove('authToken');
    throw error;
  }
}

/** 登录接口 POST /dopost/bh/port/10000 (proxied to https://www.biaohang.net/dopost/bh/port/10000) */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  //打包请求参数
  let v_thepkg ="";
  const v_sitemyid = "4";//猋行宠物速运PC.Admin
  const v_logintype = body.type;

  if(v_logintype == "account"){
    const v_logintype_num = "1";
    const v_username = body.username || '';
    const v_userpass =MD5(body.password ||'').toString();   
    v_thepkg = f_tool_scale_list([v_sitemyid, v_logintype_num, v_username, v_userpass]);
  }else if(v_logintype =="mobile"){
    const v_logintype_num = "2";
    const v_userphone = body.mobile || '';
    const v_userphonecode = body.captcha || '';
    v_thepkg = f_tool_scale_list([v_sitemyid, v_logintype_num, v_userphone, v_userphonecode]);
  }else{
    console.log("else: login");
    return;
  }
  const response = await request<any>('/dopost/bh/port/2500', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/text',
    },
    data: v_thepkg,
    ...(options || {}),
  });
  
  // Parse the response and check oret field
  if (response && response.oret =="1") {
    // Extract token from response if it exists
    const token = response.info.token || null;
    
    // Save token to cookie if it exists
    if (token) {
      Cookies.set('authToken', token, { expires: 1, path: '/' }); // Expires in 1 days
    }else{
      return {
        status: 'error',
        type: body.type,
        currentAuthority: 'guest',
      };
    }
    
    return {
      status: 'ok',
      type: body.type,
      currentAuthority: 'admin', // Default to admin, can be customized based on response
      token: token // Include token in response
    };
  } else {
    return {
      status: 'error',
      type: body.type,
      currentAuthority: 'guest',
    };
  }
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}
/** 获取设备列表 POST /dopost/bh/port/1002 (proxied to https://www.biaohang.net/dopost/bh/port/1002) */
export async function devicelist(
  params: {
    current?: number;
    pageSize?: number;
    [key: string]: any; // Allow additional properties for search filters
  }
) {
  //console.log(params);
  let v_thepkg = "";
  const v_oprgid = "1";
  const v_usertoken = Cookies.get('authToken') || "";
  const v_pageindex = (params.current || 1).toString();
  const v_pagesize = (params.pageSize || 10).toString();
  let v_querypkg = "";

  //查询参数
  const v_queryParam01=params.devicemyid || "";
  const v_queryParam02=params.logdateStart || "";
  const v_queryParam03=params.logdateEnd || "";
  const v_queryParam04=params.deviceid || "";
  const v_queryParam05=params.devicegid || "";
  const v_queryParam06=params.boxid || "";
  const v_queryParam07=params.boxsize || "";
  const v_queryParam08=params.open01 || "";
  const v_queryParam09=params.online01 || "";
  const v_queryParam10=params.extparam || "";
  const v_queryParam11=params.see || "";
  const v_queryParam12=params.see || "";  
  v_querypkg = f_tool_scale_list([v_queryParam01, v_queryParam02, v_queryParam03, v_queryParam04, v_queryParam05, v_queryParam06, v_queryParam07, v_queryParam08, v_queryParam09, v_queryParam10, v_queryParam11, v_queryParam12]);
  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_pageindex, v_pagesize, v_querypkg]);
  const v_theres =await request<API.DeviceList>('/dopost/bh/port/1002', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){
    const v_redata = v_theres.info.data || [];
    const v_retota = parseInt(v_theres.info.total || "0", 10);
    return {
      data: v_redata,
      total: v_retota,
      success: true,
    };
  }else if(v_theres.oret == "10"){
    return {
      data: [],
      total: 0,
      success: true,
    };
  }
  else{
    return {
      data: [],
      total: 0,
      success: false,
    };
  }
}

/** 设备录入 POST /dopost/bh/port/1002 */
export async function DeviceInsert(value: any, options?: { [key: string]: any }) {
  console.log(options);
  let v_thepkg = "";
  const v_oprgid = "2";
  const v_usertoken = Cookies.get('authToken') || "";
  const v_deviceid = value.deviceid || "";
  const v_boxid = value.boxid || "";
  const v_boxsize = value.boxsize || "";
  const v_extendParam = value.extendParam || "";
  const v_password = CryptoJS.MD5(value.password || "").toString().toUpperCase();

  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_deviceid, v_boxid, v_boxsize,v_extendParam,v_password]);
  const v_theres =await request<any>('/dopost/bh/port/1002', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret1002.2', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret1002.2', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}
/** 设备编辑 POST /dopost/bh/port/1002 */
export async function DeviceUpdate(value: any, options?: { [key: string]: any }) {
  console.log(value);
  let v_thepkg = "";
  const v_oprgid = "3";
  const v_usertoken = Cookies.get('authToken') || "";
  const v_deviceid = value.deviceid || "";
  const v_boxid = value.boxid || "";
  const v_boxsize = value.boxsize || "";
  const v_extendParam = value.extendParam || "";
  const v_password = CryptoJS.MD5(value.password || "").toString().toUpperCase();
  const v_devicemyid = value.devicemyid || "";
  const v_open01 = value.open01 || "";

  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_deviceid, v_boxid, v_boxsize,v_extendParam,v_password,v_open01,v_devicemyid]);
  const v_theres =await request<any>('/dopost/bh/port/1002', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret1002.3', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret1002.3', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}

/** 批量操作 POST /dopost/bh/port/N */
export async function BatchOpr(value: any, options?: { [key: string]: any }) {
  //console.log(value);
  
  let v_thepkg = "";  
  const v_usertoken = Cookies.get('authToken') || "";
  const v_deviceidlist = f_tool_scale_get(value,1);
  const v_oprParam = f_tool_scale_get(value,2);
  const v_oprgid = f_tool_scale_get(v_oprParam,1);//操作类型 
  const v_extendParam =f_tool_scale_get(v_oprParam,2);//操作类型附加参数
  const v_oprpasswd = f_tool_scale_get(v_oprParam,3);//操作类型密码

  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_deviceidlist, v_extendParam,v_oprpasswd]);
  const v_theres =await request<any>('/dopost/bh/port/2502', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret2502.1', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret2502.1', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}

/**》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》 */
/** 服务点：获取服务点列表 POST /dopost/bh/port/N (proxied to https://www.biaohang.net/dopost/bh/port/1002) */
export async function servicesitelist(
  params: {
    current?: number;
    pageSize?: number;
    [key: string]: any; // Allow additional properties for search filters
  }
) {
  //console.log(params);
  let v_thepkg = "";
  const v_oprgid = "1";
  const v_usertoken =Cookies.get('authToken') || "";
  const v_pageindex = (params.current || 1).toString();
  const v_pagesize = (params.pageSize || 30).toString();
  let v_querypkg = "";

  //查询参数
  const v_queryParam01=params.myid || "";
  const v_queryParam02=params.logdateStart || "";
  const v_queryParam03=params.logdateEnd || "";
  const v_queryParam04=params.open01 || "";
  const v_queryParam05=params.extparam || "";
  //const v_queryParam06=params.see || "";
  //const v_queryParam12=params.see || "";  
  v_querypkg = f_tool_scale_list([v_queryParam01, v_queryParam02, v_queryParam03, v_queryParam04, v_queryParam05]);
  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_pageindex, v_pagesize, v_querypkg]);
  const v_theres =await request<API.DeviceList>('/dopost/bh/port/2503', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){
    const v_redata = v_theres.info.data || [];
    const v_retota = parseInt(v_theres.info.total || "0", 10);
    return {
      data: v_redata,
      total: v_retota,
      success: true,
    };
  }else if(v_theres.oret == "10"){
    return {
      data: [],
      total: 0,
      success: true,
    };
  }
  else{
    return {
      data: [],
      total: 0,
      success: false,
    };
  }
}

/** 服务点：录入服务点 POST /dopost/bh/port/N */
export async function ServicesiteInsert(value: any, options?: { [key: string]: any }) {
  console.log(options);
  let v_thepkg = "";
  const v_oprgid = "2";
  const v_usertoken = Cookies.get('authToken') || "";
  const v_siteid = value.myid || "";
  const v_sitename = value.name || "";
  const v_sitephone = value.phone || "";  
  const v_siteaddress = value.address || "";
  const v_sitelocal = value.local || "";
  const v_demandpoint = value.demandpoint || "";
  const v_siteopen01 = value.open01 || "";
  const v_siteopentime = value.opentime || "";  
  const v_extendParam = value.extendParam || "";
  const v_password = CryptoJS.MD5(value.password || "").toString().toUpperCase();


  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_sitename,v_siteaddress,v_sitephone, v_sitelocal,v_demandpoint,v_siteopen01,v_extendParam,v_password,v_siteopentime]);
  const v_theres =await request<any>('/dopost/bh/port/2503', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret2503.2', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret2503.2', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}
/** 服务点：编辑服务点 */
export async function ServicesiteUpdate(value: any, options?: { [key: string]: any }) {
  console.log(value);
  let v_thepkg = "";
  const v_oprgid = "3";
  const v_usertoken = Cookies.get('authToken') || "";
  const v_siteid = value.myid || "";
  const v_sitename = value.name || "";
  const v_sitephone = value.phone || "";  
  const v_siteaddress = value.address || "";
  const v_sitelocal = value.local || "";
  const v_demandpoint = value.demandpoint || "";
  const v_siteopen01 = value.open01 || "";
  const v_siteopentime = value.opentime || "";
  const v_extendParam = value.extendParam || "";
  const v_password = CryptoJS.MD5(value.password || "").toString().toUpperCase();


  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken,v_sitename,v_siteaddress,v_sitephone, v_sitelocal,v_demandpoint,v_siteopen01,v_extendParam,v_password,v_siteid,v_siteopentime]);
  const v_theres =await request<any>('/dopost/bh/port/2503', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret2503.3', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret2503.3', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}

/**》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》 */
/** 订单：订单列表 POST /dopost/bh/port/N (proxied to https://www.biaohang.net/dopost/bh/port/1002) */
export async function orderlist(
  params: {
    current?: number;
    pageSize?: number;
    [key: string]: any; // Allow additional properties for search filters
  }
) {
  //console.log(params);
  let v_thepkg = "";
  const v_oprgid = "1";
  const v_usertoken =Cookies.get('authToken') || "";
  const v_pageindex = (params.current || 1).toString();
  const v_pagesize = (params.pageSize || 30).toString();
  let v_querypkg = "";

  //查询参数
  const v_queryParam01=params.myid || "";
  const v_queryParam02=params.logdateStart || "";
  const v_queryParam03=params.logdateEnd || "";
  const v_queryParam04=params.open01 || "";
  const v_queryParam05=params.extparam || "";
  const v_queryParam06=params.userid || "";
  const v_queryParam07=params.orderpos || "";
  const v_queryParam08=params.servicewayid || "";
  const v_queryParam09=params.servicesiteid || "";
  const v_queryParam10=params.servicewayidB || "";
  const v_queryParam11=params.servicesiteidB || "";
  const v_queryParam12=params.Aname || "";  
  const v_queryParam13=params.Aphone || "";  
  const v_queryParam14=params.Bname || "";  
  const v_queryParam15=params.Bphone || "";  
  const v_queryParam16=params.paywayid || "";    
  v_querypkg = f_tool_scale_list([v_queryParam01, v_queryParam02, v_queryParam03, v_queryParam04, v_queryParam05,v_queryParam06,v_queryParam07,v_queryParam08,v_queryParam09,v_queryParam10,v_queryParam11,v_queryParam12,v_queryParam13,v_queryParam14,v_queryParam15,v_queryParam16]);
  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_pageindex, v_pagesize, v_querypkg]);
  const v_theres =await request<API.DeviceList>('/dopost/bh/port/2504', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){
    const v_redata = v_theres.info.data || [];
    const v_retota = parseInt(v_theres.info.total || "0", 10);
    return {
      data: v_redata,
      total: v_retota,
      success: true,
    };
  }else if(v_theres.oret == "10"){
    return {
      data: [],
      total: 0,
      success: true,
    };
  }
  else{
    return {
      data: [],
      total: 0,
      success: false,
    };
  }
}

/**》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》 */
/** 服务点：获取店员列表 POST /dopost/bh/port/N (proxied to https://www.biaohang.net/dopost/bh/port/1002) */
export async function ServicemanList(
  params: {
    current?: number;
    pageSize?: number;
    [key: string]: any; // Allow additional properties for search filters
  }
) {
  //console.log(params);
  let v_thepkg = "";
  const v_oprgid = "1";
  const v_usertoken =Cookies.get('authToken') || "";
  const v_pageindex = (params.current || 1).toString();
  const v_pagesize = (params.pageSize || 30).toString();
  let v_querypkg = "";

  //查询参数
  const v_queryParam01=params.myid || "";
  const v_queryParam02=params.logdateStart || "";
  const v_queryParam03=params.logdateEnd || "";
  const v_queryParam04=params.open01 || "";
  const v_queryParam05=params.extparam || "";
  const v_queryParam06=params.name || "";
  const v_queryParam07=params.phone || "";  
  const v_queryParam08=params.service01 || ""; 
  v_querypkg = f_tool_scale_list([v_queryParam01, v_queryParam02, v_queryParam03, v_queryParam04, v_queryParam05,v_queryParam06,v_queryParam07,v_queryParam08]);
  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_pageindex, v_pagesize, v_querypkg]);
  const v_theres =await request<API.DeviceList>('/dopost/bh/port/2505', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){
    const v_redata = v_theres.info.data || [];
    const v_retota = parseInt(v_theres.info.total || "0", 10);
    return {
      data: v_redata,
      total: v_retota,
      success: true,
    };
  }else if(v_theres.oret == "10"){
    return {
      data: [],
      total: 0,
      success: true,
    };
  }
  else{
    return {
      data: [],
      total: 0,
      success: false,
    };
  }
}

/** 服务点：录入店员资料 POST /dopost/bh/port/N */
export async function ServicemanInsert(value: any, options?: { [key: string]: any }) {
  console.log(options);
  let v_thepkg = "";
  const v_oprgid = "2";
  const v_usertoken = Cookies.get('authToken') || "";

  const v_userphone = value.phone || "";  
  const v_userroleid = value.roleid || "";
  const v_useropen01 = value.open01 || "";
  const v_username = value.name || "";
  const v_usersex = value.sex || "";
  const v_userbirth = value.birth || "";
  const v_userbirthaddress = value.birthaddress || "";
  const v_userID = value.ID || "";
  const v_userphonesos = value.phonesos || "";  
  const v_userIDpic0 = value.IDpic0 || "";
  const v_userIDpic1 = value.IDpic1 || "";  
  const v_usernote = value.note || "";
  const v_userservice01 = value.service01 || "";  
  const v_useraddress = value.address || "";
  const v_siteid = value.siteid || "";

  const v_extendParam = value.extendParam || "";
  const v_password = CryptoJS.MD5(value.password || "").toString().toUpperCase();


  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_userphone, v_userroleid, v_useropen01, v_username, v_usersex, v_userbirth, v_userbirthaddress, v_userID, v_userphonesos, v_userIDpic0, v_userIDpic1, v_usernote, v_userservice01, v_useraddress, v_siteid, v_extendParam, v_password]);
  const v_theres =await request<any>('/dopost/bh/port/2505', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret2505.2', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret2505.2', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}
/** 服务点：编辑店员资料 */
export async function ServicemanUpdate(value: any, options?: { [key: string]: any }) {
  console.log(value);
  let v_thepkg = "";
  const v_oprgid = "3";
  const v_usertoken = Cookies.get('authToken') || "";

  const v_userphone = value.phone || "";  
  const v_userroleid = value.roleid || "";
  const v_useropen01 = value.open01 || "";
  const v_username = value.name || "";
  const v_usersex = value.sex || "";
  const v_userbirth = value.birth || "";
  const v_userbirthaddress = value.birthaddress || "";
  const v_userID = value.ID || "";
  const v_userphonesos = value.phonesos || "";  
  const v_userIDpic0 = value.IDpic0 || "";
  const v_userIDpic1 = value.IDpic1 || "";  
  const v_usernote = value.note || "";
  const v_userservice01 = value.service01 || "";  
  const v_useraddress = value.address || "";
  const v_siteid = value.siteid || "";
  const v_siteuserid = value.myid || "";

  const v_extendParam = value.extendParam || "";
  const v_password = CryptoJS.MD5(value.password || "").toString().toUpperCase();


  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_userphone, v_userroleid, v_useropen01, v_username, v_usersex, v_userbirth, v_userbirthaddress, v_userID, v_userphonesos, v_userIDpic0, v_userIDpic1, v_usernote, v_userservice01, v_useraddress, v_siteid, v_siteuserid,v_extendParam, v_password]);
  const v_theres =await request<any>('/dopost/bh/port/2505', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret2505.3', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret2505.3', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}
/**》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》 */
/** 服务点：v2获取店员列表 POST /dopost/bh/port/N (proxied to https://www.biaohang.net/dopost/bh/port/1002) */
export async function ServicemanListv2(
  params: {
    current?: number;
    pageSize?: number;
    [key: string]: any; // Allow additional properties for search filters
  }
) {
  //console.log(params);
  let v_thepkg = "";
  const v_oprgid = "1";
  const v_usertoken =Cookies.get('authToken') || "";
  const v_pageindex = (params.current || 1).toString();
  const v_pagesize = (params.pageSize || 30).toString();
  let v_querypkg = "";

  //查询参数
  const v_queryParam01=params.userid || "";
  const v_queryParam02=params.logdateStart || "";
  const v_queryParam03=params.logdateEnd || "";
  const v_queryParam04=params.open01 || "";
  const v_queryParam05=params.extparam || "";
  const v_queryParam06=params.name || "";
  const v_queryParam07=params.phone || "";  
  const v_queryParam08=params.sitename || ""; 
  const v_queryParam09=params.siteid || ""; 
  v_querypkg = f_tool_scale_list([v_queryParam01, v_queryParam02, v_queryParam03, v_queryParam04, v_queryParam05,v_queryParam06,v_queryParam07,v_queryParam08,v_queryParam09]);
  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_pageindex, v_pagesize, v_querypkg]);
  const v_theres =await request<API.DeviceList>('/dopost/bh/port/2505', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){
    const v_redata = v_theres.info.data || [];
    const v_retota = parseInt(v_theres.info.total || "0", 10);
    return {
      data: v_redata,
      total: v_retota,
      success: true,
    };
  }else if(v_theres.oret == "10"){
    return {
      data: [],
      total: 0,
      success: true,
    };
  }
  else{
    return {
      data: [],
      total: 0,
      success: false,
    };
  }
}

/** 服务点：录入店员资料 POST /dopost/bh/port/N */
export async function ServicemanInsertv2(value: any, options?: { [key: string]: any }) {
  console.log(options);
  let v_thepkg = "";
  const v_oprgid = "2";
  const v_usertoken = Cookies.get('authToken') || "";

  const v_siteid = value.myid || "";
  const v_siteuserid = value.userid || "";
  const v_userroleid = value.roleid || "";
  const v_useropen01 = value.open01 || "";
  const v_usernote = value.note || "";


  const v_extendParam = value.extendParam || "";
  const v_password = CryptoJS.MD5(value.password || "").toString().toUpperCase();


  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_siteid,v_siteuserid, v_userroleid, v_useropen01, v_usernote, v_extendParam, v_password]);
  const v_theres =await request<any>('/dopost/bh/port/2505', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret2505.2', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret2505.2', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}
/** 服务点：编辑店员资料 */
export async function ServicemanUpdatev2(value: any, options?: { [key: string]: any }) {
  console.log(value);
  let v_thepkg = "";
  const v_oprgid = "3";
  const v_usertoken = Cookies.get('authToken') || "";

  const v_siteuser_myid = value.myid || "";
  const v_userroleid = value.roleid || "";
  const v_useropen01 = value.open01 || "";
  const v_usernote = value.note || "";

  const v_extendParam = value.extendParam || "";
  const v_password = CryptoJS.MD5(value.password || "").toString().toUpperCase();


  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken,v_siteuser_myid, v_userroleid, v_useropen01, v_usernote, v_extendParam, v_password]);
  const v_theres =await request<any>('/dopost/bh/port/2505', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret2505.3', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret2505.3', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}
/**》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》》 */
/** 用户会员：用户列表 POST /dopost/bh/port/N (proxied to https://www.biaohang.net/dopost/bh/port/1002) */
export async function UserList(
  params: {
    current?: number;
    pageSize?: number;
    [key: string]: any; // Allow additional properties for search filters
  }
) {
  //console.log(params);
  let v_thepkg = "";
  const v_oprgid = "1";
  const v_usertoken =Cookies.get('authToken') || "";
  const v_pageindex = (params.current || 1).toString();
  const v_pagesize = (params.pageSize || 30).toString();
  let v_querypkg = "";

  //查询参数
  const v_queryParam01=params.myid || "";
  const v_queryParam02=params.logdateStart || "";
  const v_queryParam03=params.logdateEnd || "";
  const v_queryParam04=params.open01 || "";
  const v_queryParam05=params.extparam || "";
  const v_queryParam06=params.name || "";
  const v_queryParam07=params.phone || "";  
  const v_queryParam08=params.idveri01 || ""; 
  v_querypkg = f_tool_scale_list([v_queryParam01, v_queryParam02, v_queryParam03, v_queryParam04, v_queryParam05,v_queryParam06,v_queryParam07,v_queryParam08]);
  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_pageindex, v_pagesize, v_querypkg]);
  const v_theres =await request<API.DeviceList>('/dopost/bh/port/2506', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){
    const v_redata = v_theres.info.data || [];
    const v_retota = parseInt(v_theres.info.total || "0", 10);
    return {
      data: v_redata,
      total: v_retota,
      success: true,
    };
  }else if(v_theres.oret == "10"){
    return {
      data: [],
      total: 0,
      success: true,
    };
  }
  else{
    return {
      data: [],
      total: 0,
      success: false,
    };
  }
}

/** 用户会员：录入 POST /dopost/bh/port/N */
export async function UserInsert(value: any, options?: { [key: string]: any }) {
  console.log(options);
  let v_thepkg = "";
  const v_oprgid = "2";
  const v_usertoken = Cookies.get('authToken') || "";

  const v_userphone = value.phone || "";  
  const v_userroleid = value.roleid || "";
  const v_useropen01 = value.open01 || "";
  const v_username = value.name || "";
  const v_usersex = value.sex || "";
  const v_userbirth = value.birth || "";
  const v_userbirthaddress = value.birthaddress || "";
  const v_userID = value.ID || "";
  const v_userphonesos = value.phonesos || "";  
  const v_userIDpic0 = value.IDpic0 || "";
  const v_userIDpic1 = value.IDpic1 || "";  
  const v_usernote = value.note || "";
  const v_userservice01 = value.service01 || "";  
  const v_useraddress = value.address || "";
  const v_siteid = value.siteid || "";

  const v_extendParam = value.extendParam || "";
  const v_password = CryptoJS.MD5(value.password || "").toString().toUpperCase();


  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_userphone, v_userroleid, v_useropen01, v_username, v_usersex, v_userbirth, v_userbirthaddress, v_userID, v_userphonesos, v_userIDpic0, v_userIDpic1, v_usernote, v_userservice01, v_useraddress, v_siteid, v_extendParam, v_password]);
  const v_theres =await request<any>('/dopost/bh/port/2506', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret2506.2', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret2506.2', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}
/** 用户会员：编辑 */
export async function UserUpdate(value: any, options?: { [key: string]: any }) {
  console.log(value);
  let v_thepkg = "";
  const v_oprgid = "3";
  const v_usertoken = Cookies.get('authToken') || "";

  const v_userid = value.myid || "";
  const v_username = value.name || "";
  const v_userphone = value.phone || "";  
  const v_useropen01 = value.open01 || "";
  
  

  const v_extendParam = value.extendParam || "";
  const v_password = CryptoJS.MD5(value.password || "").toString().toUpperCase();


  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_password,v_extendParam, v_userid, v_username, v_userphone, v_useropen01]);
  const v_theres =await request<any>('/dopost/bh/port/2506', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){    
    Cookies.set('theoret2506.3', "1", { expires: 1, path: '/' });
    return {
      success: true,
    };
  }else{
    const v_theres_info = v_theres.info || "";
    Cookies.set('theoret2506.3', "0", { expires: 1, path: '/' });
    return {
      success: false,
    };
  }
}

/** 用户会员：实名认证列表 POST /dopost/bh/port/N (proxied to https://www.biaohang.net/dopost/bh/port/1002) */
export async function UserRealNameList(
  params: {
    current?: number;
    pageSize?: number;
    [key: string]: any; // Allow additional properties for search filters
  }
) {
  //console.log(params);
  let v_thepkg = "";
  const v_oprgid = "4";
  const v_usertoken =Cookies.get('authToken') || "";
  const v_pageindex = (params.current || 1).toString();
  const v_pagesize = (params.pageSize || 30).toString();
  let v_querypkg = "";

  //查询参数
  const v_queryParam01=params.myid || "";
  const v_queryParam02=params.logdateStart || "";
  const v_queryParam03=params.logdateEnd || "";
  const v_queryParam04=params.open01 || "";
  const v_queryParam05=params.extparam || "";
  v_querypkg = f_tool_scale_list([v_queryParam01, v_queryParam02, v_queryParam03, v_queryParam04, v_queryParam05]);
  v_thepkg = f_tool_scale_list([v_oprgid, v_usertoken, v_pageindex, v_pagesize, v_querypkg]);
  const v_theres =await request<API.DeviceList>('/dopost/bh/port/2506', {
    method: 'POST',
    data: v_thepkg // 使用 data 传递参数
  });
  if(v_theres.oret == "1"){
    const v_redata = v_theres.info.data || [];
    const v_retota = parseInt(v_theres.info.total || "0", 10);
    return {
      data: v_redata,
      total: v_retota,
      success: true,
    };
  }else if(v_theres.oret == "10"){
    return {
      data: [],
      total: 0,
      success: true,
    };
  }
  else{
    return {
      data: [],
      total: 0,
      success: false,
    };
  }
}


/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
